import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
    logged: boolean;
    id?: string;
    username?: string;
    /** M4: scadenza della sessione (epoch in secondi) per l'idratazione locale. */
    exp?: number;
}

/**
 * Stato iniziale del slice, riusato dal `preloadedState` dello store quando in
 * localStorage non c'è una sessione valida (A4).
 */
export const initialUserState: UserState = {
    logged: false,
};

export const userSlice = createSlice({
    name: 'user',
    initialState: initialUserState,
    reducers: {
        setUser: (state, action: PayloadAction<UserState>) => {
            state.logged = Boolean(action.payload.logged);
            state.id = action.payload.id;
            state.username = action.payload.username;
            state.exp = action.payload.exp;
        },
        logout: () => initialUserState,
    },
});

export const { setUser, logout } = userSlice.actions;
export default userSlice.reducer;
